import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Avatar } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
const ClearFormButtonHtmlRenderer = (props) => {
    const { data } = props;
    let src = data === null || data === void 0 ? void 0 : data.src;
    const pub_src = data === null || data === void 0 ? void 0 : data.pub_src;
    const label = data === null || data === void 0 ? void 0 : data.label;
    const href = data === null || data === void 0 ? void 0 : data.href;
    const size = data === null || data === void 0 ? void 0 : data.size;
    const color = data === null || data === void 0 ? void 0 : data.color;
    const clearForm = props.clearForm;
    const use_public_storage = props.useStorageUrl ? props.useStorageUrl : false;
    if (use_public_storage && pub_src) {
        src = pub_src;
    }
    const default_theme = useTheme();
    const theme = createTheme({
        palette: {
            primary: {
                light: default_theme.palette.primary.light,
                main: color ? color : default_theme.palette.primary.main,
                dark: default_theme.palette.primary.dark,
                contrastText: default_theme.palette.primary.contrastText,
            }
        },
    });
    return (React.createElement("div", null,
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Button, { variant: 'contained', href: href ? href : "", color: "primary", "aria-label": "open drawer", sx: { marginLeft: 'auto' }, startIcon: src ? React.createElement(Avatar, { src: src }) : undefined, size: size, onClick: clearForm },
                React.createElement(Typography, { variant: "h6", noWrap: true, component: "div" }, label)))));
};
export default ClearFormButtonHtmlRenderer;
//# sourceMappingURL=ClearFormButtonHtmlRenderer.js.map